import { FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';
import { getSiteConfig, getCustomerNumbers } from './topContext';
import { getPageIdOfElement } from './getPageIdOfElement';

/**
 * Build url to QR code - the url is depending on which environment (localhost, staging or prod)
 * On staging a auto login url is built and the tester can log direct ind without Mit ID
 * The QR url is selected depending on values from topContext
 * @param formConfig
 * @param elementId
 */
export const buildUrlForQrCode = (formConfig: FormConfig | undefined, elementId: string) => {
    const isRunningLocalhost = window.location.href.indexOf('localhost') > -1;
    const pageId = getPageIdOfElement(formConfig, elementId);
    const siteConfig = getSiteConfig();
    const customerNumbers = getCustomerNumbers();

    const urlToFormPage = `https://${siteConfig.originalHost}/skader/formularer/${formConfig?.formId}/${pageId}/?skipLoadPrompt=true&deeplink=true`;

    // QR url for localhost
    if (isRunningLocalhost) {
        return `${siteConfig.defaultRedirect}${formConfig?.formId}/${pageId}/?skipLoadPrompt=true&deeplink=true`;
    }

    // QR url for staging
    if (siteConfig.env === 'dev') {
        const apiDomain = siteConfig.originalHost.replace(`${siteConfig.dscmNumber}.mit`, 'api');
        return `https://${apiDomain}/test-jwt/v2/customerid/${customerNumbers[0]}?environment=${
            siteConfig.environment
        }&url=${encodeURIComponent(urlToFormPage)}`;
    }

    // QR url for prod
    if (siteConfig.env === 'prod') {
        return urlToFormPage;
    }

    return '';
};
